class ClipboardButton extends HTMLElement {
  constructor() {
    super();
    this.labelElement = this.querySelector("[data-promo-cta-el]");
    this.clipboardText = this.getAttribute("clipboard-text");
    this.clipboardSucessText = this.getAttribute("clipboard-success-text");
    this.clipboardDefaultText = this.labelElement.innerText;

    this.copyContent = this.copyContent.bind(this);
  }

  connectedCallback() {
    this.addEventListener("click", () => this.copyContent(this.clipboardText));
  }

  copyContent = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      if (this.clipboardSucessText) {
        this.labelElement.innerText = this.clipboardSucessText;

        setTimeout(() => {
          this.labelElement.innerText = this.clipboardDefaultText
        }, 3000);
      }
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };
}

if (!customElements.get("clipboard-button")) {
  customElements.define("clipboard-button", ClipboardButton);
}
